import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imageLT from "./LandscapeThumbnail.jpg";
import imagePS from "./PortraitSmallImage.jpg";
import imagePT from "./PortraitThumbnail.jpg";

export default () => {
	return (
		<CssColumnGrid columns={5}>
			<Text semiBold text="landscape (small)" />
			<Text semiBold text="landscape (large)" />
			<Text semiBold text="portrait (small)" />
			<Text semiBold text="portrait (large)" />
			<Text semiBold text="no image" />
			<CsiImage size="icon" src={imageLT} />
			<CsiImage size="icon" src={imageLS} />
			<CsiImage size="icon" src={imagePT} />
			<CsiImage size="icon" src={imagePS} />
			<CsiImage size="icon" />
		</CssColumnGrid>
	);
};